import { axiosPrivateFileUpload } from "../api/axios";
import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import useAuth from "./useAuth";
import { refreshAccessTokenOnce } from "./refreshLock";

const useAxiosPrivateFileUpload = () => {
  const refresh = useRefreshToken();
  const { auth } = useAuth();

  useEffect(() => {
    const requestIntercept = axiosPrivateFileUpload.interceptors.request.use(
      config => {
        if (!config.headers['Authorization'] && auth?.accessToken) {
          config.headers['Authorization'] = `Bearer ${auth.accessToken}`;
        }
        return config;
      },
      error => Promise.reject(error)
    );

    const responseIntercept = axiosPrivateFileUpload.interceptors.response.use(
      response => response,
      async error => {
        const prevRequest = error?.config;

        if (error?.response?.status === 401 && prevRequest && !prevRequest.sent) {
          prevRequest.sent = true;
          const newAccessToken = await refreshAccessTokenOnce(refresh);
          prevRequest.headers = prevRequest.headers ?? {};
          prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
          return axiosPrivateFileUpload(prevRequest);
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivateFileUpload.interceptors.request.eject(requestIntercept);
      axiosPrivateFileUpload.interceptors.response.eject(responseIntercept);
    };
  }, [auth?.accessToken, refresh]);

  return axiosPrivateFileUpload;
};

export default useAxiosPrivateFileUpload;
